import { toast } from "react-toastify";

import {
  RequestBulkOperationRequestBodyType,
  RequestBulkOperationResponseBodyType,
} from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";
import { ApiRequest } from "../types/api";

const requestBulkOperation = async (
  data: ApiRequest<RequestBulkOperationRequestBodyType, any, any>
) => {
  const resp = await api.post<
    RequestBulkOperationResponseBodyType,
    RequestBulkOperationRequestBodyType
  >("/v2/shops/bulk", data.body);
  return resp.data;
};

export const useRequestBulkOperation = () => {
  return useMutation<
    RequestBulkOperationResponseBodyType,
    Error,
    ApiRequest<RequestBulkOperationRequestBodyType, any, any>,
    any
  >({
    mutationFn: async (
      data: ApiRequest<RequestBulkOperationRequestBodyType, any, any>
    ) => requestBulkOperation(data),
    onSuccess: (data) => {
      if (data.operation.existing) {
        toast.warning(`Operation ${data.operation.id} is already in progress!`);
      } else {
        toast.success(`Operation ${data.operation.id} started!`);
      }
    },
  });
};
